export const UPDATE_FORM_SCREEN = "STATE_SET_FORM_SCREEN";
export const SET_FORM_SCREENS_VISIBILITY = "STATE_SET_FORM_SCREENS";
export const UPDATE_FORM_FIELD = "STATE_UPDATE_FORM_FIELD";
export const SET_FORM_FIELDS_VISIBILITY = "STATE_SET_FORM_FIELDS";
export const UPDATE_FORM_FIELD_VALUE = "STATE_UPDATE_FORM_FIELD_VALUE";
export const SET_FORM_FIELDS_VALUES = "STATE_SET_FORM_FIELDS_VALUES";

export const NEXT_SCREEN = "NEXT_SCREEN";
export const BACK = "BACK";
export const SET_SCREEN = "SET_SCREEN";
export const SET_REVIEW_VISIBLE = "SET_REVIEW_VISIBLE";
export const SET_REVIEW_SCREEN_INDEX = "SET_REVIEW_SCREEN_INDEX";
export const SET_LOAN_TYPE = "SET_LOAN_TYPE";
export const SET_PASSED_PARAMS = "SET_PASSED_PARAMS";
export const SET_LOGO = "SET_LOGO";
export const ENABLE_DEBUG = "ENABLE_DEBUG";
export const FIELDS_VISIBILITY_VERSION_UP = "FIELDS_VISIBILITY_VERSION_UP";
export const SCREENS_VISIBILITY_VERSION_UP = "SCREENS_VISIBILITY_VERSION_UP";